module.exports = __webpack_public_path__ + "media/images/illustrations/gift_card_with_sparkle-4136e577d05310730ed87c3610b74d8b.svg";